import Firebase from './firebase.js';
import React from 'react';

const FirebaseContext = React.createContext(null);
 
export default Firebase;
 
export { FirebaseContext};